import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import Card, { CardContent } from 'material-ui/Card';

const styles = theme => ({
	cardContainer: {
		display: 'flex',
		alignItems: 'stretch',
	},
	card: {
		font: '300 16px/26px "Sans Source Pro", sans-serif',
		marginTop: '10px',
		padding: '20px',
	},
  cardTitle: {
    marginTop: 10,
  }
});

class GuidingParam extends React.Component {

  render() {
  	const { classes, item } = this.props;

    return (
    	<Grid item xs={12} md={6} lg={4} className={classes.cardContainer}>
        <Card className={classes.card}>
        	<CardContent>
        		<h2 className={classes.cardTitle}>{item.title}</h2>
        		<p>{item.content}</p>
        	</CardContent>
        </Card>
      </Grid>
    );
  }
}

GuidingParam.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GuidingParam);






// WEBPACK FOOTER //
// ./src/components/GuidingParam.js